import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';
import { AuthShell } from '../components/auth-shell';
import { usePageTitle } from '../lib/page-title';

export function ResetRequestPage() {
  usePageTitle('Reset password');
  const { auth } = useAuth();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [requested, setRequested] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    await auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/auth/callback`,
    });
    setSubmitting(false);
    // Always show the same outcome so this form cannot confirm whether an
    // address has an account.
    setRequested(true);
  }

  if (requested) {
    return (
      <AuthShell>
        <h1>Check your inbox</h1>
        <p role="status">
          If an account exists for that address, a password reset link is on its way.
        </p>
        <p>
          <Link className="text-link" to="/signin">
            Back to sign in
          </Link>
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1>Forgot your password?</h1>
      <p>Enter your account email and we’ll send a link to choose a new one.</p>
      <form className="auth-form" onSubmit={(event) => void submit(event)}>
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send reset link'}
        </button>
      </form>
      <p>
        <Link className="text-link" to="/signin">
          Back to sign in
        </Link>
      </p>
    </AuthShell>
  );
}
